import React, { useState } from 'react';
import '../../../entrydoor.css';

const InteriorFinishSideLiteEticom = ({ value, onChange, label = 'Interior Finish:', disabled = false }) => {
    const [selectedInteriorFinishSideLiteEticom, setSelectedInteriorFinishSideLiteEticom] = useState(value || "White");

    const handleInteriorFinishSideLiteEticomChange = (e) => {
        setSelectedInteriorFinishSideLiteEticom(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} disabled={disabled} htmlFor="InteriorFinishSideLiteEticom">{label}</label>
            <select style={{ display: "none" }}
                disabled={disabled}
                id="InteriorFinishSideLiteEticom"
                value={selectedInteriorFinishSideLiteEticom}
                onChange={handleInteriorFinishSideLiteEticomChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="White">{selectedInteriorFinishSideLiteEticom === "White" ? "White ✔" : "White"}</option>
                <option value="Gentek">{selectedInteriorFinishSideLiteEticom === "Gentek" ? "Gentek ✔" : "Gentek"}</option>
            </select>
        </div>
    );
};

export default InteriorFinishSideLiteEticom;
